import {
  LandingPageNumber,
  VehiclePageNumber,
  AftermarketPageNumber,
  HistoryPageNumber,
  ImageCapturePageNumber,
  ExteriorPageNumber,
  InteriorPageNumber,
  MechanicalPageNumber,
  ContactPageNumber,
  CertificatePageNumber,
  LoadingPageNumber
} from '../../../constants'
import { isExteriorPage, isInteriorPage } from './pageMaps'

const PAGE_NUMBER_TO_ID = {
  [LandingPageNumber]: 'ico_home', // A
  [VehiclePageNumber]: 'ico_vehdetails', // C
  [AftermarketPageNumber]: 'ico_aft-mkt', // D
  [ImageCapturePageNumber]: 'ico_condition_img', // E
  [ExteriorPageNumber]: 'ico_condition_ext', // F
  [InteriorPageNumber]: 'ico_condition_int', // G
  [MechanicalPageNumber]: 'ico_condition_mech', // H
  [HistoryPageNumber]: 'ico_vehhist', // H1
  [ContactPageNumber]: 'ico_contact', // J
  [LoadingPageNumber]: 'ico_contact', // J2
  [CertificatePageNumber]: 'ico_thank' // K
}

const getPageId = pageInfo => PAGE_NUMBER_TO_ID[pageInfo.page]

const getPageHierarchy = (pageId, landingContext) => {
  if (!pageId) {
    return
  }

  let sectionName = pageId
  let pageName = pageId

  if (pageId === 'ico_thank' && landingContext?.experienceState?.dealerIsKbycDealer) {
    pageName = 'kbyc_email_lp'
  } else if (pageId.includes('condition')) {
    sectionName = 'ico_condition'
  } else if (pageId.includes('button::subnav::')) {
    sectionName = 'ico_condition'
    // Only for Interior and Exterior, with Mechanical we dont catch event for sub nav
    pageName = isInteriorPage(pageId) ? 'ico_condition_int' : isExteriorPage(pageId) ? 'ico_condition_ext' : 'ico_condition_mech'
  }
  return ['ico', sectionName, pageName] // [superSection, sectionName, pageName]
}

const PAGE_LOAD_TAG_INDEX = {
  [LandingPageNumber]: 'ico-fp-01', // A
  [VehiclePageNumber]: 'ico-fp-02', // C
  [AftermarketPageNumber]: 'ico-fp-03', // D
  [ImageCapturePageNumber]: 'ico-fp-04', // E
  [ExteriorPageNumber]: 'ico-fp-05', // F
  [InteriorPageNumber]: 'ico-fp-06', // G
  [MechanicalPageNumber]: 'ico-fp-07', // H
  [ContactPageNumber]: 'ico-fp-08', // J
  [CertificatePageNumber]: 'ico-fp-09', // K
  [HistoryPageNumber]: 'ico-fp-10' // L
}

const getPageLoadTagIndex = (pageInfo, landingContext) => {
  const baseTagIndex = PAGE_LOAD_TAG_INDEX[pageInfo.page]

  if (baseTagIndex === 'ico-fp-09' && landingContext?.experienceState?.dealerIsKbycDealer) {
    return 'ico-lp-10'
  }

  return baseTagIndex
}

const CONDITION_TAB_TAG_INDEX = {
  ico_condition_ext: 'ico-fp-05',
  ico_condition_int: 'ico-fp-06',
  ico_condition_mech: 'ico-fp-07'
}

const getConditionTabIndex = pageInfo => CONDITION_TAB_TAG_INDEX[pageInfo.linkName]

const CONDITION_TABS = {
  exterior: 'ico_condition_ext', // F
  interior: 'ico_condition_int', // G
  mechanical: 'ico_condition_mech' // H
}

const BACK_TAG_INDEX = {
  [VehiclePageNumber]: 'ico-fe-011', // C3
  [AftermarketPageNumber]: 'ico-fe-012', // D1
  [ImageCapturePageNumber]: 'ico-fe-018', // E5
  [ContactPageNumber]: 'ico-fe-029', // J3,
  [ExteriorPageNumber]: 'ico-fe-124', // H3,
  [InteriorPageNumber]: 'ico-fe-124', // H3,
  [MechanicalPageNumber]: 'ico-fe-124', // H3,,
  [HistoryPageNumber]: 'ico-fe-047' // L1
}

const getBackButtonTagIndex = pageInfo => BACK_TAG_INDEX[pageInfo.page]

const IMAGE_CAPTURE_PHOTO_BOX = {
  1: 'front',
  2: 'rear',
  3: `driver's side`,
  4: `passenger's side`,
  5: 'dashboard',
  6: 'seating'
}

const getCategoryName = category => IMAGE_CAPTURE_PHOTO_BOX[category]

export { PAGE_NUMBER_TO_ID, CONDITION_TABS, getPageId, getPageHierarchy, getPageLoadTagIndex, getConditionTabIndex, getBackButtonTagIndex, getCategoryName }
